import TemplateView from '../TemplateView'
import SearchFilter from './SearchFilter'
import messageResource from '../messageResource'


export default class SearchWithDropdownButton extends TemplateView {
    constructor({
        emptySelectionMessageKey = '',
        dropdownButtonClick = () => {},
        onSearchChangedCallback = (text) => {},
        onSearchFocusedCallback = () => {},
        onSelectedItemClickCallback = () => {},
        renderSelectedItemHtml = (item) => {},
        inputMaxLength,
    }) {
        super()

        this.params = {
            emptySelectionMessageKey,
            dropdownButtonClick,
            onSearchChangedCallback,
            onSearchFocusedCallback,
            onSelectedItemClickCallback,
            renderSelectedItemHtml,
            inputMaxLength,
        }

        this.state = {
            searchText: '',
            selectedItem: '',
            focused: false,
            disabled: false,
            emptySelection: false,
            emptySelectionSet: false,
            emptySetMessageKey: '',
        }

        this.onAnyStatePropertyChanged(['selectedItem', 'emptySelection', 'emptySelectionSet'], () => {
            if (this.state.emptySelectionSet)
                this.$selectedItem.html('<div class="emptySet">' + messageResource.getEscapedMessage(this.state.emptySetMessageKey) + '</div>')
            else if (this.state.emptySelection)
                this.$selectedItem.html('<div class="emptySelection">' + messageResource.getEscapedMessage(this.params.emptySelectionMessageKey) + '</div>')
            else if (this.state.selectedItem)
                this.$selectedItem.html(this.params.renderSelectedItemHtml(this.state.selectedItem))
        })

        this.onStatePropertyChanged('focused', (focused) => {
            this.$selectedItem.toggle(!focused)
            this.$searchInputPlaceholder.toggle(focused)
            this.$el.toggleClass('focused', focused)
        })

        this.onStatePropertyBecameTrue('focused', () => {
            this.search.setState({
                text: this.state.searchText
            })
            this.params.onSearchChangedCallback(this.state.searchText)
            this.search.focus()
            this.params.onSearchFocusedCallback()
        })

        this.onStatePropertyChanged('disabled', (disabled) => {
            this.$el.toggleClass('disabled', disabled)
        })
    }

    templateHtml() {
        return '<div class="comboboxButton">' +
               '  <div class="selectedItem"></div>' +
               '  <div class="searchInputPlaceholder"></div>' +
               '  <div class="dropdownButton"></div>' +
               '</div>'
    }

    afterRender() {
        this.$selectedItem = this.find('.selectedItem')
        this.$searchInputPlaceholder = this.find('.searchInputPlaceholder')
        this.$dropdownButton = this.find('.dropdownButton')


        this.search = new SearchFilter({
            placeholder: '',
            additionalClass: '',
            onChange: (text) => {
                this.params.onSearchChangedCallback(text)
            },
            onClear: () => {
                this.search.setState({text: ''})
                this.setState({searchText: ''})
                this.params.onSearchChangedCallback('')
            },
            maxLength: this.params.inputMaxLength,
        }).init(this.find('.searchInputPlaceholder'))

        this.$dropdownButton.click(() => {
            if (!this.state.disabled)
                this.params.dropdownButtonClick()
        })

        this.$selectedItem.click(() => {
            if (!this.state.disabled) {
                this.params.onSelectedItemClickCallback()
            }
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/components/SearchWithDropdownButton.js